import { Component, OnInit, ViewChild } from '@angular/core';
import { TransactionComponent } from 'src/app/componentsWallet/components/transaction/transaction.component';
import { GiftCardService } from 'src/app/services/gift-card.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.page.html',
  styleUrls: ['./transactions.page.scss'],
})
export class TransactionsPage implements OnInit {
  @ViewChild('transactionEl')
  transactionEl: TransactionComponent;

  public loaded = false;

  constructor(
    private _giftCardSv: GiftCardService,
    private _storageSv: StorageService
  ) {}

  ngOnInit() {}

  async ionViewDidEnter() {
    let giftCard = this._storageSv.getLocalStorage('giftCard');
    if (giftCard) {
      this._giftCardSv.giftCard = JSON.parse(giftCard);
    }
    if (this._giftCardSv.giftCard && this._giftCardSv.client) {
      await this.transactionEl.setClient(this._giftCardSv.client);
    } else {
      await this.transactionEl.getParams();
      this.transactionEl.uri = '';
    }
  }

  ionViewWillEnter() {
    this.loaded = true;
  }

  ionViewWillLeave() {
    this.loaded = false;
  }
}
